import React, { useCallback, useState } from "react";
import { Table } from "react-bootstrap";
import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import { serverUrl, fetcher, swrConfig } from "../helpers/utility";
import variables from "../styles/utils.module.scss";
import Loading from "./loading";
import TabWithFilter from "./TabWithFilter";
import { useForm } from "react-hook-form";

export default function EnquiriesContent() {
  const navigate = useNavigate();
  const steps = { OPEN: "OPEN", CLOSED: "CLOSED" };
  const [step, setStep] = useState(steps.OPEN);
  const { register } = useForm();

  const getEnquiryUrl = () => {
    const baseUrl = `${serverUrl}/enquiry`;
    if (step === steps.CLOSED) {
      return `${baseUrl}?status=closed`;
    }
    return `${baseUrl}?status=open`;
  };

  const {
    data: enquiryData,
    isLoading: enquiryIsLoading,
  } = useSWR(getEnquiryUrl(), fetcher, swrConfig);

  function hasEnquiries() {
    return enquiryData && enquiryData?.enquiries?.length > 0;
  }

  const goToEnquiry = useCallback(
    ({ enquiryId }) => {
      navigate(`/enquiry?enquiryId=${enquiryId}`);
    },
    [navigate]
  );

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return "";
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h1 className="h3">Enquiries</h1>
      <div className="space-y-4">
        <TabWithFilter
          tabs={[
            {
              label: "Open",
              onClick: () => {
                setStep(steps.OPEN);
              },
              active: step === steps.OPEN,
            },
            {
              label: "Closed",
              onClick: () => {
                setStep(steps.CLOSED);
              },
              active: step === steps.CLOSED,
            },
          ]}
          filterInputId={"reference"}
          filterRegister={register}
          filterPlaceholder="Reference"
        />

        {enquiryIsLoading ? <Loading inline={true} inlineHeight={300} /> : null}

        {step === steps.OPEN ? (
          <>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Reference</th>
                  <th>Name / Known As</th>
                  <th className="d-none d-md-table-cell">Location</th>
                  <th className="d-none d-md-table-cell">Created</th>
                  <th style={{ width: "66px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {enquiryData?.enquiries?.length > 0 &&
                  enquiryData.enquiries.map((enquiry) => {
                    return (
                      <tr
                        key={enquiry._id}
                        onClick={() => {
                          goToEnquiry({ enquiryId: enquiry._id });
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <td>{enquiry.placement?.reference || ""}</td>
                        <td>{enquiry.placement?.firstname || ""}</td>
                        <td className="d-none d-md-table-cell">
                          {enquiry.location?.name || ""}
                        </td>
                        <td className="d-none d-md-table-cell">
                          {formatDate(enquiry.created)}
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <i
                            className={`bi bi-search`}
                            style={{
                              fontSize: "14px",
                              color: variables.green,
                              padding: "3px",
                              cursor: "pointer",
                            }}
                            onClick={(event) => {
                              goToEnquiry({ enquiryId: enquiry._id });
                              event.stopPropagation();
                            }}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>

            {!enquiryIsLoading && !hasEnquiries() ? (
              <div
                className="d-flex flex-column justify-content-center"
                style={{ marginBottom: 10 }}
              >
                No open enquiries.
              </div>
            ) : null}
          </>
        ) : null}

        {step === steps.CLOSED ? (
          <>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Reference</th>
                  <th>Name / Known As</th>
                  <th className="d-none d-md-table-cell">Location</th>
                  <th className="d-none d-md-table-cell">Created</th>
                  <th className="d-none d-md-table-cell">Status</th>
                  <th style={{ width: "66px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {enquiryData?.enquiries?.length > 0 &&
                  enquiryData.enquiries.map((enquiry) => {
                    return (
                      <tr
                        key={enquiry._id}
                        onClick={() => {
                          goToEnquiry({ enquiryId: enquiry._id });
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <td>{enquiry.placement?.reference || ""}</td>
                        <td>{enquiry.placement?.firstname || ""}</td>
                        <td className="d-none d-md-table-cell">
                          {enquiry.location?.name || ""}
                        </td>
                        <td className="d-none d-md-table-cell">
                          {formatDate(enquiry.created)}
                        </td>
                        <td className="d-none d-md-table-cell">
                          {enquiry.completed ? "Completed" : enquiry.cancelled ? "Cancelled" : ""}
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <i
                            className={`bi bi-search`}
                            style={{
                              fontSize: "14px",
                              color: variables.green,
                              padding: "3px",
                              cursor: "pointer",
                            }}
                            onClick={(event) => {
                              goToEnquiry({ enquiryId: enquiry._id });
                              event.stopPropagation();
                            }}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>

            {!enquiryIsLoading && !hasEnquiries() ? (
              <div
                className="d-flex flex-column justify-content-center"
                style={{ marginBottom: 10 }}
              >
                No closed enquiries found.
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
}

